import styled, { css } from 'styled-components';
import StatusTag from '@/components/StatusTag';

export const Box = styled.div`
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  background-color: ${(props) => props.theme.colors['neutral-10']};
  padding: 25px;
  margin: 0 -20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 25px 105px;
    margin: 0 -100px;
  }
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  white-space: nowrap;
`;

export const Tag = styled(StatusTag)`
  margin-right: 8px;
  display: flex;
`;

export const StatusAndPartnerBox = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 150%;
`;

export const ContactLink = styled.a<{ isDisabled?: boolean }>`
  color: ${(props) =>
    props.isDisabled ? props.theme.colors['neutral-90'] : props.theme.colors['primary-60']};
  display: flex;
  font-size: 14px;
  line-height: 21px;
  align-items: center;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'initial')};
  svg {
    margin-right: 6px;

    color: ${(props) =>
      props.isDisabled
        ? props.theme.colors['neutral-90']
        : props.theme.colors['primary-60']} !important;
  }
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DateBox = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 150%;
  margin-right: 8px;
  white-space: nowrap;
`;

const timeOpenAlert = css`
  color: ${(props) => props.theme.colors['neutral-0']};
  background: #ff991c;
`;

const timeOpenRegular = css`
  border: 1px solid ${(props) => props.theme.colors['neutral-100']};
`;

export const TimeOpenText = styled.p<{ days: number }>`
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  ${(props) => (props.days >= 31 ? timeOpenAlert : timeOpenRegular)}
`;
